import { useAuth0 } from '@auth0/auth0-react';

export const useGetClinicianId = () => {
  const { user } = useAuth0();
  const auth0ClinicianId: string = user?.['https://tacklit.com/clinicianId'] || user?.['sub'] || '';
  return { auth0ClinicianId };
};
